import store from '../../store'
import createAxios from './api'

const PATH = '/v1/users'

export default {
  async joinUserOnRdss() {
    const axios = await createAxios()
    await axios.put(store.state.remoteConfig.rdssApiUrl + PATH, store.state.currentUser)
  },

  async updateMyUserOnRdss(user) {
    const axios = await createAxios()
    await axios.put(store.state.remoteConfig.rdssApiUrl + `${PATH}/self`, user)
  },

  async updateMyLocaleOnRdss(locale) {
    const axios = await createAxios()
    await axios.put(store.state.remoteConfig.rdssApiUrl + `${PATH}/self/locale`, locale)
  },

  async updateUserOnRdss(id, user) {
    const axios = await createAxios()
    await axios.put(store.state.remoteConfig.rdssApiUrl + `${PATH}/${id}`, user)
  },
  async getUserOnRdss() {
    const axios = await createAxios()
    const resp = await axios.get(store.state.remoteConfig.rdssApiUrl + `${PATH}/self`)
    return resp.data
  }

}
